export default "__VITE_ASSET__Cqi5ymJZ__"